/**
 * MEMO Landing Page — All JavaScript
 * Handles: gallery, variant selector, Ajax ATC, FAQ accordion, scroll reveal, smooth scroll
 */

(function () {
  'use strict';

  /* ========================================
   * 1. Scroll Reveal
   * ======================================== */
  function initScrollReveal() {
    var reveals = document.querySelectorAll('.mlp-reveal');
    if (!reveals.length) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('mlp-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

    reveals.forEach(function (el) { observer.observe(el); });
  }

  /* ========================================
   * 2. Smooth Scroll for Anchor Links
   * ======================================== */
  function initSmoothScroll() {
    document.addEventListener('click', function (e) {
      var link = e.target.closest('a[href^="#"]');
      if (!link) return;
      var targetId = link.getAttribute('href').slice(1);
      // Support both id and data-anchor attributes
      var target = document.querySelector('[data-anchor="' + targetId + '"]') ||
                   document.querySelector('[data-anchor="' + targetId.replace('#', '') + '"]');
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  }

  /* ========================================
   * 3. Image Gallery (Offer Section)
   * ======================================== */
  function initGallery() {
    var thumbs = document.querySelectorAll('[data-mlp-thumb]');
    var mainImg = document.querySelector('.mlp-offer__img');
    if (!thumbs.length || !mainImg) return;

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        // Update main image
        var url = this.getAttribute('data-image-url');
        mainImg.style.opacity = '0';
        setTimeout(function () {
          mainImg.src = url;
          mainImg.style.opacity = '1';
        }, 200);

        // Update active state
        thumbs.forEach(function (t) { t.classList.remove('mlp-offer__thumb--active'); });
        this.classList.add('mlp-offer__thumb--active');
      });
    });
  }

  /* ========================================
   * 4. Variant Selector
   * ======================================== */
  function initVariantSelector() {
    var radios = document.querySelectorAll('[data-mlp-variant]');
    if (!radios.length) return;

    radios.forEach(function (radio) {
      radio.addEventListener('change', function () {
        // Update selected state
        document.querySelectorAll('.mlp-offer__variant-option').forEach(function (opt) {
          opt.classList.remove('mlp-offer__variant-option--selected');
        });
        this.closest('.mlp-offer__variant-option').classList.add('mlp-offer__variant-option--selected');

        // Update price display
        var priceEl = document.querySelector('[data-mlp-price]');
        var comparePriceEl = document.querySelector('[data-mlp-compare-price]');
        if (priceEl && this.dataset.price) {
          priceEl.textContent = this.dataset.price;
        }
        if (comparePriceEl && this.dataset.comparePrice) {
          comparePriceEl.textContent = this.dataset.comparePrice;
        }
      });
    });
  }

  /* ========================================
   * 5. Ajax Add to Cart
   * Uses the theme's own event system:
   * - POST to /cart/add.js with FormData + sections
   * - Fetch /cart.js for full cart
   * - Dispatch variant:add + cart:change events
   * - CartDrawer listens and updates + opens
   * ======================================== */
  function initAddToCart() {
    var atcButton = document.querySelector('[data-mlp-add-to-cart]');
    if (!atcButton) return;

    atcButton.addEventListener('click', function () {
      var btn = this;
      var selectedRadio = document.querySelector('[data-mlp-variant]:checked');
      if (!selectedRadio) return;

      var variantId = selectedRadio.value;
      btn.setAttribute('disabled', 'disabled');
      btn.setAttribute('aria-busy', 'true');
      var originalText = btn.innerHTML;
      btn.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10" opacity="0.25"/><path d="M12 2a10 10 0 010 20" stroke-linecap="round"><animateTransform attributeName="transform" type="rotate" from="0 12 12" to="360 12 12" dur="0.8s" repeatCount="indefinite"/></path></svg> Adding...';

      // Build sections to request (same as theme does)
      var sectionsToBundle = ['variant-added'];
      document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', {
        bubbles: true,
        detail: { sections: sectionsToBundle }
      }));

      var formData = new FormData();
      formData.set('id', variantId);
      formData.set('quantity', '1');
      formData.set('sections', sectionsToBundle.join(','));
      formData.set('sections_url', Shopify.routes.root + 'variants/' + variantId);

      fetch(Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        body: formData,
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      })
        .then(function (response) {
          return response.json().then(function (data) {
            return { ok: response.ok, data: data };
          });
        })
        .then(function (result) {
          btn.removeAttribute('disabled');
          btn.removeAttribute('aria-busy');

          if (result.ok) {
            btn.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M5 13l4 4L19 7"/></svg> Added!';
            setTimeout(function () { btn.innerHTML = originalText; }, 2000);

            // Fetch updated cart then dispatch theme events
            fetch(Shopify.routes.root + 'cart.js')
              .then(function (r) { return r.json(); })
              .then(function (cartContent) {
                cartContent.sections = result.data.sections;

                // variant:add — opens the cart drawer
                document.documentElement.dispatchEvent(new CustomEvent('variant:add', {
                  bubbles: true,
                  detail: {
                    items: result.data.hasOwnProperty('items') ? result.data.items : [result.data],
                    cart: cartContent
                  }
                }));

                // cart:change — updates cart drawer content
                document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
                  bubbles: true,
                  detail: {
                    baseEvent: 'variant:add',
                    cart: cartContent
                  }
                }));
              });
          } else {
            btn.innerHTML = originalText;
            alert(result.data.description || 'Could not add to cart. Please try again.');
          }
        })
        .catch(function () {
          btn.removeAttribute('disabled');
          btn.removeAttribute('aria-busy');
          btn.innerHTML = originalText;
          alert('Something went wrong. Please try again.');
        });
    });
  }

  /* ========================================
   * 6. Product Stars (Offer section)
   * Injects a star rating above the theme-rendered product title.
   * Uses dataset config from the offer section wrapper.
   * ======================================== */
  function initProductStars() {
    var offer = document.querySelector('[data-anchor="memo-offer"]');
    if (!offer) return;
    var title = offer.querySelector('.product-info__title');
    if (!title || title.parentNode.querySelector('.mlp-product-stars')) return;

    var ratingText = offer.getAttribute('data-rating-text') || '4.8/5 from 252 reviews';
    var link = document.createElement('a');
    link.href = '#memo-reviews';
    link.className = 'mlp-product-stars';
    link.setAttribute('aria-label', 'Jump to customer reviews');

    var starSvg = '<svg width="18" height="18" viewBox="0 0 24 24" fill="#F4C542"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>';
    link.innerHTML =
      '<span class="mlp-product-stars__stars">' + starSvg + starSvg + starSvg + starSvg + starSvg + '</span>' +
      '<span class="mlp-product-stars__text">' + ratingText + '</span>';

    title.parentNode.insertBefore(link, title);
  }

  /* ========================================
   * 7. FAQ Accordion
   * ======================================== */
  function initFAQ() {
    var toggles = document.querySelectorAll('[data-mlp-faq-toggle]');
    if (!toggles.length) return;

    toggles.forEach(function (toggle) {
      toggle.addEventListener('click', function () {
        var item = this.closest('.mlp-faq__item');
        var answer = item.querySelector('[data-mlp-faq-answer]');
        var isOpen = item.classList.contains('mlp-faq__item--open');

        // Close all others
        document.querySelectorAll('.mlp-faq__item--open').forEach(function (openItem) {
          openItem.classList.remove('mlp-faq__item--open');
          var openAnswer = openItem.querySelector('[data-mlp-faq-answer]');
          openAnswer.style.maxHeight = '0';
          openItem.querySelector('[data-mlp-faq-toggle]').setAttribute('aria-expanded', 'false');
        });

        // Toggle current
        if (!isOpen) {
          item.classList.add('mlp-faq__item--open');
          answer.style.maxHeight = answer.scrollHeight + 'px';
          this.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  /* ========================================
   * 7. Video Testimonials Carousel
   * ======================================== */
  function initVideoCards() {
    var cards = document.querySelectorAll('.mlp-videos__card');
    if (!cards.length) return;

    cards.forEach(function (card) {
      card.addEventListener('click', function () {
        var url = card.getAttribute('data-video-url');
        if (!url) return;

        // Pause + reset any other card
        cards.forEach(function (other) {
          if (other !== card) {
            var ov = other.querySelector('video');
            if (ov) ov.pause();
            other.classList.remove('playing');
          }
        });

        var video = card.querySelector('video');
        if (!video) {
          video = document.createElement('video');
          video.src = url;
          video.controls = false;
          video.playsInline = true;
          video.loop = true;
          video.preload = 'metadata';
          video.setAttribute('playsinline', '');
          card.appendChild(video);
          video.play().catch(function () {});
          card.classList.add('playing');
        } else if (video.paused) {
          video.play().catch(function () {});
          card.classList.add('playing');
        } else {
          video.pause();
          card.classList.remove('playing');
        }
      });
    });
  }

  /* ========================================
   * 8. Sticky CTA — slides up when hero scrolls out of view
   * ======================================== */
  function initStickyCTA() {
    var btn = document.querySelector('[data-mlp-sticky-cta]');
    var hero = document.querySelector('.mlp-hero');
    if (!btn) return;

    var state = { heroVisible: true, cartOpen: false };

    function render() {
      var show = !state.heroVisible && !state.cartOpen;
      btn.classList.toggle('mlp-sticky-cta--visible', show);
    }

    // Hide when hero is in view; show when scrolled past it
    if (hero && typeof IntersectionObserver !== 'undefined') {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { state.heroVisible = e.isIntersecting; });
        render();
      }, { threshold: 0.05, rootMargin: '0px 0px -40px 0px' }).observe(hero);
    } else {
      state.heroVisible = false;
    }

    // Hide when cart drawer is open so it doesn't overlay the checkout button
    var drawer = document.querySelector('cart-drawer');
    if (drawer) {
      var checkCart = function () {
        var rect = drawer.getBoundingClientRect();
        var style = window.getComputedStyle(drawer);
        var open =
          drawer.hasAttribute('open') ||
          drawer.classList.contains('is-open') ||
          drawer.classList.contains('active') ||
          drawer.classList.contains('is-active') ||
          drawer.getAttribute('aria-hidden') === 'false' ||
          (style.visibility !== 'hidden' &&
           style.display !== 'none' &&
           rect.width > 100 &&
           rect.right > 0 &&
           rect.left < window.innerWidth);
        if (open !== state.cartOpen) {
          state.cartOpen = open;
          render();
        }
      };
      new MutationObserver(checkCart).observe(drawer, {
        attributes: true,
        attributeFilter: ['class', 'open', 'aria-hidden', 'style']
      });
      ['cart-drawer:open','cart-drawer:close','cart:open','cart:close','dialog:open','dialog:close'].forEach(function (e) {
        document.addEventListener(e, checkCart, true);
      });
      checkCart();
    }

    render();
  }

  /* ========================================
   * Init
   * ======================================== */
  function init() {
    initScrollReveal();
    initSmoothScroll();
    initGallery();
    initVariantSelector();
    initAddToCart();
    initProductStars();
    initFAQ();
    initVideoCards();
    initStickyCTA();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
